import React from 'react';
import styles from '../../gen2_widgets/base/CommonSettings.module.scss';

function SettingsSection ({ children, className = '', ...rest }) {
  return (
    <div className={`${styles['settings-section']} ${className}`} {...rest}>
      {children}
    </div>
  )
}

export default SettingsSection;